import { Box, Card, Grid, useMediaQuery } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { ThemeContext } from "styled-components";
import EyeBrow from "component/commonComponents/eyeBrow/eyeBrow";
import Typography from "component/MarketPlace/Typography";
import { Button } from "component/MarketPlace/ButtonComponents";
import { TruncatedText } from "component/MarketPlace/Typography/Typography.style";

export interface IDeviceSelectionOEM {
  isPickup?: any;
  locale?: any;
  availableDevices?: any;
  handleSelection?: any;
  selectedDevice?: any;
  eyeBrowColor: (props: any) => void;
  eyeBrowBackgroundColor: (props: any) => void;
}

const DeviceSelectionOEM = (props: IDeviceSelectionOEM) => {
  const {
    isPickup,
    locale,
    availableDevices,
    handleSelection,
    selectedDevice,
    eyeBrowColor,
    eyeBrowBackgroundColor
  } = props;

  const theme = useContext(ThemeContext);
  const [confirmedDevice, setConfirmedDevice] = useState<any>(null);
  let selectDeviceComponentText: any = null;
  let commonStatusText: any = null;
  const xsUp = useMediaQuery(`(min-width:${theme.breakpoints.xs})`);
  const smUp = useMediaQuery(`(min-width:${theme.breakpoints.sm})`);
  if (locale) {
    const { selectDeviceComponent, commonStatus } = locale;
    selectDeviceComponentText = selectDeviceComponent;
    commonStatusText = commonStatus;
  }

  const exception_type = {
    PREMIUM: "Premium",
    STANDARD: "Standard",
    RECOMMENDED: "RECOMMENDED",
    NO_EXCEPTION_REQUIRED: "NO_EXCEPTION_REQUIRED",
    EXCEPTION_REQUIRED: "EXCEPTION_REQUIRED",
    NA: "NA",
  };

  const FIELD_TO_GET_NAME = {
    TYPE: "type",
    EXCEPTION_TYPE: "exception_type",
  };
  const exceptionLabel = (item: any, field: string) => {
    if (!item || !item[field]) {
      return "";
    }

    switch (isPickup ? item[field] : item[field].value) {
      case exception_type.RECOMMENDED:
      case exception_type.EXCEPTION_REQUIRED:
      case exception_type.PREMIUM:
      case exception_type.STANDARD:
        if (isPickup) {
          return commonStatusText?.[item[field]?.toUpperCase()];
        } else {
          return commonStatusText?.[item[field]?.value?.toUpperCase()];
        }
      default:
        return "";
    }
  };

  const renderEyeBrow = (item: any) => {
    const eyeBrowData = {
      item,
      field: isPickup ? FIELD_TO_GET_NAME.TYPE : FIELD_TO_GET_NAME.EXCEPTION_TYPE,
      isPickup,
      theme,
    };
    return exceptionLabel(
      item,
      isPickup ? FIELD_TO_GET_NAME.TYPE : FIELD_TO_GET_NAME.EXCEPTION_TYPE
    ) ? (
      <EyeBrow
        color={eyeBrowColor({...eyeBrowData})}
        backgroundColor={eyeBrowBackgroundColor({...eyeBrowData})}
        text={exceptionLabel(
          item,
          isPickup ? FIELD_TO_GET_NAME.TYPE : FIELD_TO_GET_NAME.EXCEPTION_TYPE
        )}
      />
    ) : (
      <></>
    );
  };

  useEffect(() => {
    if (!!selectedDevice) {
      if (!confirmedDevice) {
        const newSelectedDevice =
          availableDevices.find((d: any) => d.uid === selectedDevice.uid) ??
          null;
        setConfirmedDevice(newSelectedDevice);
        handleSelection(newSelectedDevice);
      }
    }
  }, [selectedDevice, confirmedDevice]);

  const handleSelectedDevice = (item: any) => {
    setConfirmedDevice(item);
    handleSelection(item);
  };

  return (
    <>
      <Box padding="16px">
        <Grid container justifyContent="center" alignItems="center">
          {availableDevices?.map((item: any, index: number) => {
            return (
              <Grid
                item
                xs={12}
                sm={8}
                md={6}
                lg={availableDevices?.length > 2 ? 3 : 6}
                key={index}
                padding="0 12px"
              >
                <Card
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "column",
                    padding: "16px",
                    height: `${smUp ? "536px" : "auto"}`,
                    position: "relative",
                    border: `1px solid ${theme.uptimeColors.grayScales.lightBorder}`,
                    borderRadius: "8px",
                    boxShadow: `${theme.uptimeColors.grayScales.boxShadow} -4px 4px`
                  }}
                >
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    width="100%"
                  >
                    <img
                      width="fit-content"
                      height={smUp ? "180px" : (xsUp ? "140px" : "100px")}
                      src={item?.model_picture || item?.picture}
                      alt="laptop"
                      title="laptop"
                    />
                  </Box>
                  <Box>
                    <Box>{renderEyeBrow(item)}</Box>
                    <Typography variant="overline" color="text.secondary">
                      {item?.model_type || item?.type}
                    </Typography>
                    <TruncatedText maxlines={1} variant="h5">
                      {item?.name || item?.user_device_profile}
                    </TruncatedText>
                    {item?.processor && (
                      <TruncatedText
                        maxlines={1}
                        color="text.secondary"
                        sx={{ padding: " 4px 0" }}
                        variant="body2"
                      >
                        {item?.processor}
                      </TruncatedText>
                    )}
                    {item?.memory && (
                      <TruncatedText
                        maxlines={1}
                        color="text.secondary"
                        sx={{ padding: " 4px 0" }}
                        variant="body2"
                      >
                        {item?.memory}
                      </TruncatedText>
                    )}
                    {item?.hard_drive && (
                      <TruncatedText
                        maxlines={1}
                        color="text.secondary"
                        sx={{ padding: " 4px 0" }}
                        variant="body2"
                      >
                        {item?.hard_drive}
                      </TruncatedText>
                    )}
                    {item?.graphics_processor && (
                      <TruncatedText
                        maxlines={1}
                        color="text.secondary"
                        sx={{ padding: " 4px 0" }}
                        variant="body2"
                      >
                        {item?.graphics_processor}
                      </TruncatedText>
                    )}
                  </Box>

                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    paddingTop="75px"
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      sx={{ borderRadius: "4px", heigt: "36px", width: "100%" }}
                      onClick={() => handleSelectedDevice(item)}
                      id="btn-select-device"
                      disabled={
                        confirmedDevice && confirmedDevice.uid === item.uid
                          ? true
                          : false
                      }
                    >
                      {confirmedDevice && confirmedDevice.uid === item.uid
                        ? selectDeviceComponentText?.selected
                        : selectDeviceComponentText?.select}
                    </Button>
                  </Box>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </>
  );
};

export default DeviceSelectionOEM;
